// import store from "@/state/store";

export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: 'Login',
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters["auth/loggedIn"]) {
      //     // Redirect to the home page instead
      //     next({ name: "default" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/account/register.vue'),
    meta: {
      title: 'Register',
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters["auth/loggedIn"]) {
      //     // Redirect to the home page instead
      //     next({ name: "default" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('../views/account/forgot-password.vue'),
    meta: {
      title: 'Forgot Password',
      // beforeResolve(routeTo, routeFrom, next) {
      //   // If the user is already logged in
      //   if (store.getters["auth/loggedIn"]) {
      //     // Redirect to the home page instead
      //     next({ name: "default" });
      //   } else {
      //     // Continue to the login page
      //     next();
      //   }
      // },
    },
  },

  // DASHBOARD
  {
    path: '/',
    name: 'default',
    meta: {
      title: 'Dashboard',
      authRequired: true,
    },
    component: () => import('../views/index.vue'),
  },

  // COMPANY
  {
    path: '/companies/edit',
    name: 'companies-edit',
    meta: {
      title: 'Ubah Company',
      authRequired: true,
    },
    component: () => import('../views/companies/edit'),
  },

  //SettingPPN
  {
    path: '/companies/editppn',
    name: 'companies-editppn',
    meta: {
      title: 'Ubah Default Ppn',
      authRequired: true,
    },
    component: () => import('../views/companies/editppn'),
  },

  // MASTER ITEM
  {
    path: '/masters/items/create',
    name: 'masters-items-create',
    meta: {
      title: 'Master Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/create'),
  },
  {
    path: '/masters/items',
    name: 'masters-items',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/list'),
  },
  {
    path: '/masters/itemsAgen',
    name: 'masters-itemsAgen',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/DaftarItemAgen'),
  },
  {
    path: '/masters/importItemsAgen',
    name: 'masters-importItemsAgen',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/importSaldoStockAwal'),
  },

  {
    path: '/masters/importItemsAgenNew',
    name: 'masters-importItemsAgenNew',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/importSaldoStockAwalAgen'),
  },

  {
    path: '/masters/importStockGudangLain',
    name: 'masters-importStockGudangLain',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/importStockGudangLain'),
  },

  {
    path: '/masters/importHargaAgen',
    name: 'masters-importHargaAgen',
    meta: {
      title: 'Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/importSaldoHargaAwal'),
  },
  {
    path: '/masters/settingHarga',
    name: 'masters-settingHarga',
    meta: {
      title: 'Setting Harga',
      authRequired: true,
    },
    component: () => import('../views/masters/items/SettingHarga'),
  },
  {
    path: '/masters/items/import',
    name: 'masters-items-import',
    meta: {
      title: 'Import Item',
      authRequired: true,
    },
    component: () => import('../views/masters/items/import'),
  },

  // MASTER Status Apps
  {
    path: '/masters/statusApps',
    name: 'masters-statusapps',
    meta: {
      title: 'Daftar Status Apps',
      authRequired: true,
    },
    component: () => import('../views/masters/status-apps/list'),
  },

  // MASTER SALES
  {
    path: '/masters/sales',
    name: 'masters-sales',
    meta: {
      title: 'Daftar Sales',
      authRequired: true,
    },
    component: () => import('../views/masters/sales/list'),
  },

  {
    path: '/masters/gudangLain',
    name: 'masters-gudangLain',
    meta: {
      title: 'Daftar Gudang',
      authRequired: true,
    },
    component: () => import('../views/masters/gudangLain/list'),
  },

  // MASTER SALES APP
  {
    path: '/masters/sales-app',
    name: 'masters-sales-app',
    meta: {
      title: 'Daftar Sales App',
      authRequired: true,
    },
    component: () => import('../views/masters/sales-app/list'),
  },

  // MASTER CUSTOMER
  {
    path: '/masters/customers/create',
    name: 'masters-customers-create',
    meta: {
      title: 'Customer',
      authRequired: true,
    },
    component: () => import('../views/masters/customers/create'),
  },
  {
    path: '/masters/customers',
    name: 'masters-customers',
    meta: {
      title: 'Daftar Customer',
      authRequired: true,
    },
    component: () => import('../views/masters/customers/list'),
  },

  {
    path: '/masters/Lapcustomers',
    name: 'masters-Lapcustomers',
    meta: {
      title: 'Lap. Customer',
      authRequired: true,
    },
    component: () => import('../views/masters/customers/lap-customer'),
  },

  {
    path: '/masters/customers/import',
    name: 'masters-customers-import',
    meta: {
      title: 'Import Customer',
      authRequired: true,
    },
    component: () => import('../views/masters/customers/import'),
  },

  // MASTER SUPLIER
  {
    path: '/masters/suppliers',
    name: 'masters-suppliers',
    meta: {
      title: 'Daftar Supplier',
      authRequired: true,
    },
    component: () => import('../views/masters/suppliers/list'),
  },

  // MASTER Bank
  {
    path: '/masters/keuangan/bank',
    name: 'masters-bank',
    meta: {
      title: 'Daftar Bank',
      authRequired: true,
    },
    component: () => import('../views/masters/keuangan/bank/list'),
  },

  // MASTER KAS
  {
    path: '/masters/keuangan/kas',
    name: 'masters-kas',
    meta: {
      title: 'Daftar Kas',
      authRequired: true,
    },
    component: () => import('../views/masters/keuangan/kas/list'),
  },

  // Pemasukan Kas
  {
    path: '/masters/keuangan/jenispemasukan',
    name: 'masters-jenispemasukan',
    meta: {
      title: 'Daftar Jenis Pemasukan Kas',
      authRequired: true,
    },
    component: () => import('../views/masters/keuangan/pemasukan/list'),
  },

  // Pengeluaran Kas
  {
    path: '/masters/keuangan/jenispengeluaran',
    name: 'masters-jenispengeluaran',
    meta: {
      title: 'Daftar Jenis Pengeluaran Kas',
      authRequired: true,
    },
    component: () => import('../views/masters/keuangan/pengeluaran/list'),
  },

  // PEMBELIAN
  {
    path: '/transactions/pembelian/create/select-items',
    name: 'transactions-pembelian-create',

    meta: {
      title: 'Pembelian - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pembelian/created/select-items'),
  },

  {
    path: '/transactions/pembelian/create/items-cart',
    name: 'transactions-pembelian-create-cart',
    meta: {
      title: 'Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pembelian/created/items-cart'),
  },

  {
    path: '/transactions/pembelian/create/items-cart-pembelian',
    name: 'transactions-pembelian-create-cart-pembelian',
    meta: {
      title: 'Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pembelian/created/createPembelian'),
  },

  {
    path: '/transactions/pembelian/create/items-cart-review-pembelian',
    name: 'transactions-pembelian-create-cart-review-pembelian',
    meta: {
      title: 'Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pembelian/created/previewPembelian'),
  },

  {
    path: '/transactions/pembelian/create/items-cart-approval-pembelian',
    name: 'transactions-pembelian-create-cart-approval-pembelian',
    props: true,
    meta: {
      title: 'Preview Pembelian',
      authRequired: true,
      reload: 'true',
    },
    component: () =>
      import(
        '../views/transactions/pembelian/created/previewApprovalPembelian'
      ),
  },

  {
    path: '/transactions/pembelian/create/invoice',
    name: 'transactions-pembelian-create-invoice',
    meta: {
      title: 'Pembelian',
      authRequired: true,
    },
    component: () => import('../views/transactions/pembelian/created/invoice'),
  },

  {
    path: '/transactions/pembelian',
    name: 'transactions-pembelian-list',
    meta: {
      title: 'Daftar Pembelian',
      authRequired: true,
    },
    component: () => import('../views/transactions/pembelian/list'),
  },

  // SALES ORDER
  {
    path: '/transactions/sales-order/create/select-items',
    name: 'transactions-sales-order-create',
    meta: {
      title: 'Sales Order - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/sales-order/create/select-items'),
  },

  {
    path: '/transactions/sales-order/create/items-cart',
    name: 'transactions-sales-order-create-cart',
    meta: {
      title: 'Sales Order',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/sales-order/create/createSalesOrder'),
  },

  {
    path: '/transactions/sales-order/create/invoice',
    name: 'transactions-sales-order-create-invoice',
    meta: {
      title: 'Sales Order - Invoice',
      authRequired: true,
    },
    component: () => import('../views/transactions/sales-order/create/invoice'),
  },

  {
    path: '/transactions/sales-order/create/previewinvoice',
    name: 'transactions-sales-order-preview-invoice',
    meta: {
      title: 'Sales Order - Invoice',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/sales-order/create/previewSalesOrder'),
  },

  {
    path: '/transactions/sales-order',
    name: 'transactions-sales-order-list',
    meta: {
      title: 'Daftar Sales Order',
      authRequired: true,
    },
    component: () => import('../views/transactions/sales-order/list'),
  },

  // PENJUALAN
  {
    path: '/transactions/penjualan/create/cart',
    name: 'transactions-invoice-create',
    meta: {
      title: 'Penjualan',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/createInvoice'),
  },

  {
    path: '/transactions/penjualan/import',
    name: 'transaction-invoice-import',
    meta: {
      title: 'Import Customer',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/import'),
  },

  {
    path: '/transactions/penjualan/create/previewCart',
    name: 'transactions-invoice-preview-create',
    meta: {
      title: 'Penjualan',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/previewPenjualan'),
  },

  {
    path: '/transactions/penjualan/create/select-items',
    name: 'transactions-invoice-select-item',
    meta: {
      title: 'Penjualan - Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/select-items'),
  },

  {
    path: '/transactions/penjualan',
    name: 'transactions-invoice-list',
    meta: {
      title: 'Daftar Invoice',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/list'),
  },

  {
    path: '/transactions/point',
    name: 'transactions-point-list',
    meta: {
      title: 'Transfer Point',
      authRequired: true,
    },
    component: () => import('../views/transactions/point/list'),
  },

  {
    path: '/transactions/historyPoint',
    name: 'transactions-historyPoint-list',
    meta: {
      title: 'History Transfer Point',
      authRequired: true,
    },
    component: () => import('../views/transactions/point/listHistoryPoint'),
  },

  {
    path: '/transactions/mutasiPoint',
    name: 'transactions-mutasiPoint-list',
    meta: {
      title: 'Mutasi Transfer Point',
      authRequired: true,
    },
    component: () => import('../views/transactions/point/listMutasiPoint'),
  },

  {
    path: '/transactions/salesPoint',
    name: 'transactions-salesPoint-list',
    meta: {
      title: 'Sales Point',
      authRequired: true,
    },
    component: () => import('../views/transactions/point/salesPointlist'),
  },

  {
    path: '/transactions/penjualan/print',
    name: 'transactions-invoice-print',
    meta: {
      title: 'Print Invoice',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/print'),
  },

  {
    path: '/transactions/point/printHistoryPoint',
    name: 'transactions-historyPoint-print',
    meta: {
      title: 'Detail History Point',
      authRequired: true,
    },
    component: () => import('../views/transactions/point/printHistoryPoint'),
  },

  {
    path: '/Report/agen/print',
    name: 'transactions-invoice-print-agen',
    meta: {
      title: 'Print Invoice',
      authRequired: true,
    },
    component: () => import('../views/Report/agen/print'),
  },

  {
    path: '/transactions/penjualan/printLaba',
    name: 'transactions-invoice-print-laba',
    meta: {
      title: 'Print Invoice Laba',
      authRequired: true,
    },
    component: () => import('../views/transactions/penjualan/print-laba'),
  },

  //Penyesuaian

  {
    path: '/transactions/penyesuaian/create/cart',
    name: 'transactions-penyesuaian-create',
    meta: {
      title: 'Penyesuaian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/penyesuaian/created/items-cart'),
  },

  {
    path: '/transactions/penyesuaian/create/select-items',
    name: 'transactions-penyesuaian-select-item',
    meta: {
      title: 'Penyesuaian - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/penyesuaian/created/select-items'),
  },

  {
    path: '/transactions/penyesuaian',
    name: 'transactions-penyesuaian-list',
    meta: {
      title: 'Daftar Penyesuaian',
      authRequired: true,
    },
    component: () => import('../views/transactions/penyesuaian/list'),
  },

  {
    path: '/transactions/penyesuaian/print',
    name: 'transactions-penyesuaian-create-invoice',
    meta: {
      title: 'Penyesuaian Clain',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/penyesuaian/created/invoice'),
  },

  //Sampling

  {
    path: '/transactions/sampling/create/cart',
    name: 'transactions-sampling-create',
    meta: {
      title: 'Sampling',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/sampling/created/items-cart'),
  },

  {
    path: '/transactions/sampling/create/select-items',
    name: 'transactions-sampling-select-item',
    meta: {
      title: 'Sampling - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/sampling/created/select-items'),
  },

  {
    path: '/transactions/sampling',
    name: 'transactions-sampling-list',
    meta: {
      title: 'Daftar Sampling',
      authRequired: true,
    },
    component: () => import('../views/transactions/sampling/list'),
  },

  {
    path: '/transactions/sampling/print',
    name: 'transactions-sampling-create-invoice',
    meta: {
      title: 'Sampling',
      authRequired: true,
    },
    component: () => import('../views/transactions/sampling/created/invoice'),
  },

  //Canvassing

  {
    path: '/transactions/canvassing/create/cart',
    name: 'transactions-canvassing-create',
    meta: {
      title: 'Canvassing',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/canvassing/created/items-cart'),
  },

  {
    path: '/transactions/canvassing/create/select-items',
    name: 'transactions-canvassing-select-item',
    meta: {
      title: 'Canvassing - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/canvassing/created/select-items'),
  },

  {
    path: '/transactions/canvassing',
    name: 'transactions-canvassing-list',
    meta: {
      title: 'Daftar Canvassing',
      authRequired: true,
    },
    component: () => import('../views/transactions/canvassing/list'),
  },

  {
    path: '/transactions/canvassing/print',
    name: 'transactions-canvassing-create-invoice',
    meta: {
      title: 'Canvassing',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/canvassing/created/invoice'),
  },

  //Migrasi

  {
    path: '/transactions/migrasi/create/cart',
    name: 'transactions-migrasi-create',
    meta: {
      title: 'Migration Stock',
      authRequired: true,
    },
    component: () => import('../views/transactions/migrasi/created/items-cart'),
  },

  {
    path: '/transactions/migrasi/create/select-items',
    name: 'transactions-migrasi-select-item',
    meta: {
      title: 'Migration Stock - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/migrasi/created/select-items'),
  },

  {
    path: '/transactions/migrasi',
    name: 'transactions-migrasi-list',
    meta: {
      title: 'Daftar Migration Stock',
      authRequired: true,
    },
    component: () => import('../views/transactions/migrasi/list'),
  },

  {
    path: '/transactions/migrasi/print',
    name: 'transactions-migrasi-create-invoice',
    meta: {
      title: 'Migration Stock',
      authRequired: true,
    },
    component: () => import('../views/transactions/migrasi/created/invoice'),
  },

  //Penyesuaian Gudang Lain

  {
    path: '/transactions/penyesuaiangudanglain/create/cart',
    name: 'transactions-penyesuaiangudanglain-create',
    meta: {
      title: 'Penyesuaian Gudang Lain',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/penyesuaiangudanglain/created/items-cart'),
  },

  {
    path: '/transactions/penyesuaiangudanglain/create/select-items',
    name: 'transactions-penyesuaiangudanglain-select-item',
    meta: {
      title: 'Penyesuaian Gudang Lain - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import(
        '../views/transactions/penyesuaiangudanglain/created/select-items'
      ),
  },

  {
    path: '/transactions/penyesuaiangudanglain',
    name: 'transactions-penyesuaiangudanglain-list',
    meta: {
      title: 'Daftar Penyesuaian Gudang Lain',
      authRequired: true,
    },
    component: () => import('../views/transactions/penyesuaiangudanglain/list'),
  },

  {
    path: '/transactions/penyesuaiangudanglain/print',
    name: 'transactions-penyesuaiangudanglain-create-invoice',
    meta: {
      title: 'Penyesuaian Gudang Lain',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/penyesuaiangudanglain/created/invoice'),
  },

  //CLAIM
  {
    path: '/transactions/claim/create/cart',
    name: 'transactions-claim-create',
    meta: {
      title: 'Claim',
      authRequired: true,
    },
    component: () => import('../views/transactions/claim/created/items-cart'),
  },

  {
    path: '/transactions/claim/create/select-items',
    name: 'transactions-claim-select-item',
    meta: {
      title: 'Claim - Daftar Item',
      authRequired: true,
    },
    component: () => import('../views/transactions/claim/created/select-items'),
  },

  {
    path: '/transactions/claim',
    name: 'transactions-claim-list',
    meta: {
      title: 'Daftar Claim',
      authRequired: true,
    },
    component: () => import('../views/transactions/claim/list'),
  },

  {
    path: '/transactions/claim/print',
    name: 'transactions-claim-create-invoice',
    meta: {
      title: 'Print Clain',
      authRequired: true,
    },
    component: () => import('../views/transactions/claim/created/invoice'),
  },

  //Mutasi Online
  {
    path: '/transactions/mutasi-online/create/cart',
    name: 'transactions-mutasi-online-create',
    meta: {
      title: 'Mutasi Online',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/mutasi-online/created/items-cart'),
  },

  {
    path: '/transactions/mutasi-online/create/select-items',
    name: 'transactions-mutasi-online-select-item',
    meta: {
      title: 'Mutasi Online - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/mutasi-online/created/select-items'),
  },

  {
    path: '/transactions/mutasi-online',
    name: 'transactions-mutasi-online-list',
    meta: {
      title: 'Daftar Mutasi Online',
      authRequired: true,
    },
    component: () => import('../views/transactions/mutasi-online/list'),
  },

  {
    path: '/transactions/mutasi-online/print',
    name: 'transactions-mutasi-online-create-invoice',
    meta: {
      title: 'Print Mutasi Online',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/mutasi-online/created/invoice'),
  },

  //Pinjaman
  {
    path: '/transactions/pinjaman/create/cart',
    name: 'transactions-pinjaman-create',
    meta: {
      title: 'Pinjaman',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pinjaman/created/items-cart'),
  },

  {
    path: '/transactions/pinjaman/create/select-items',
    name: 'transactions-pinjaman-select-item',
    meta: {
      title: 'Pinjaman - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/pinjaman/created/select-items'),
  },

  {
    path: '/transactions/pinjaman',
    name: 'transactions-pinjaman-list',
    meta: {
      title: 'Daftar Pinjaman',
      authRequired: true,
    },
    component: () => import('../views/transactions/pinjaman/list'),
  },

  {
    path: '/transactions/pinjaman/print',
    name: 'transactions-pinjaman-create-invoice',
    meta: {
      title: 'Print Pinjaman',
      authRequired: true,
    },
    component: () => import('../views/transactions/pinjaman/created/invoice'),
  },

  //Gudang Lain
  {
    path: '/transactions/gudangLain/create/cart',
    name: 'transactions-gudangLain-create',
    meta: {
      title: 'Gudang Lain',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/gudangLain/created/items-cart'),
  },

  {
    path: '/transactions/gudangLain/create/select-items',
    name: 'transactions-gudangLain-select-item',
    meta: {
      title: 'Gudang Lain - Daftar Item',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/gudangLain/created/select-items'),
  },

  {
    path: '/transactions/gudangLain',
    name: 'transactions-gudangLain-list',
    meta: {
      title: 'Daftar Gudang Lain',
      authRequired: true,
    },
    component: () => import('../views/transactions/gudangLain/list'),
  },

  {
    path: '/transactions/gudangLain/print',
    name: 'transactions-gudangLain-create-invoice',
    meta: {
      title: 'Print Gudang Lain',
      authRequired: true,
    },
    component: () => import('../views/transactions/gudangLain/created/invoice'),
  },

  //Keuangan
  {
    path: '/transactions/keuangan/bkmUmum',
    name: 'transactions-bkmumum-list',
    meta: {
      title: 'Daftar BKM Umum',
      authRequired: true,
    },
    component: () => import('../views/transactions/keuangan/bkm-umum/list'),
  },

  {
    path: '/transactions/keuangan/bkmUmum/item-cart',
    name: 'transactions-bkmumum',
    meta: {
      title: 'BKM Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-umum/create/items-cart'),
  },

  {
    path: '/transactions/keuangan/bkmUmum/select-item',
    name: 'transactions-bkmumum-jenis-pemasukan',
    meta: {
      title: 'Jenis BKM Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-umum/create/select-items.vue'),
  },

  {
    path: '/transactions/keuangan/bkmUmum/print',
    name: 'transactions-bkmumum-create-invoice',
    meta: {
      title: 'Print BKM Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-umum/create/invoice'),
  },

  {
    path: '/transactions/keuangan/bkkUmum',
    name: 'transactions-bkkumum-list',
    meta: {
      title: 'Daftar BKK Umum',
      authRequired: true,
    },
    component: () => import('../views/transactions/keuangan/bkk-umum/list'),
  },

  {
    path: '/transactions/keuangan/bkkUmum/item-cart',
    name: 'transactions-bkkumum',
    meta: {
      title: 'BKK Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-umum/create/items-cart'),
  },

  {
    path: '/transactions/keuangan/bkkUmum/select-item',
    name: 'transactions-bkkumum-jenis-pemasukan',
    meta: {
      title: 'Jenis BKK Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-umum/create/select-items.vue'),
  },

  {
    path: '/transactions/keuangan/bkkUmum/print',
    name: 'transactions-bkkUmum-create-invoice',
    meta: {
      title: 'Print BKK Umum',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-umum/create/invoice'),
  },

  {
    path: '/transactions/keuangan/bkmPenjualan',
    name: 'transactions-bkmpenjualan-list',
    meta: {
      title: 'Daftar BKM Penjualan',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-penjualan/list'),
  },

  {
    path: '/transactions/keuangan/bkmPenjualan/item-cart',
    name: 'transactions-bkmpenjualan',
    meta: {
      title: 'BKM Penjualan',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-penjualan/create/items-cart'),
  },

  {
    path: '/transactions/keuangan/bkmPenjualan/select-item',
    name: 'transactions-bkmpenjualan-jenis-pemasukan',
    meta: {
      title: 'Jenis BKM Penjualan',
      authRequired: true,
    },
    component: () =>
      import(
        '../views/transactions/keuangan/bkm-penjualan/create/select-items.vue'
      ),
  },

  {
    path: '/transactions/keuangan/bkmPenjualan/print',
    name: 'transactions-bkmpenjualan-create-invoice',
    meta: {
      title: 'Print BKM Penjualan',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkm-penjualan/create/invoice'),
  },

  {
    path: '/transactions/keuangan/bkkPembelian',
    name: 'transactions-bkkpembelian-list',
    meta: {
      title: 'Daftar BKK Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-pembelian/list'),
  },

  {
    path: '/transactions/keuangan/bkkPembelian/item-cart',
    name: 'transactions-bkkpembelian',
    meta: {
      title: 'BKK Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-pembelian/create/items-cart'),
  },

  {
    path: '/transactions/keuangan/bkkPembelian/select-item',
    name: 'transactions-bkkpembelian-jenis-pemasukan',
    meta: {
      title: 'Jenis BKK Pembelian',
      authRequired: true,
    },
    component: () =>
      import(
        '../views/transactions/keuangan/bkk-pembelian/create/select-items.vue'
      ),
  },

  {
    path: '/transactions/keuangan/bkkPembelian/print',
    name: 'transactions-bkkpembelian-create-invoice',
    meta: {
      title: 'Print BKK Pembelian',
      authRequired: true,
    },
    component: () =>
      import('../views/transactions/keuangan/bkk-pembelian/create/invoice'),
  },

  //Laporan
  {
    path: '/Report/Persediaan',
    name: 'report-posisi-persediaan',
    meta: {
      title: 'Lap. Posisi Persediaan',
      authRequired: true,
    },
    component: () => import('../views/Report/Persediaan/posisi-persediaan'),
  },

  {
    path: '/Report/Persediaan/Agen',
    name: 'report-posisi-persediaan-agen',
    meta: {
      title: 'Lap. Posisi Persediaan Agen',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Persediaan/Agen/posisi-persediaan-agen.vue'),
  },

  {
    path: '/Report/PersediaanMigrationStock',
    name: 'report-posisi-persediaan-migration-stock',
    meta: {
      title: 'Lap. Posisi Persediaan Migration Stock',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Persediaan/posisi-persediaan-migration-stock'),
  },

  {
    path: '/Report/Persediaan/KartuStock',
    name: 'report-kartu-stock',
    meta: {
      title: 'Lap. Kartu Stock',
      authRequired: true,
    },
    component: () => import('../views/Report/Persediaan/kartu-stock'),
  },

  {
    path: '/Report/Persediaan/Agen/KartuStockAgen',
    name: 'report-kartu-stock-agen',
    meta: {
      title: 'Lap. Kartu Stock Agen',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Persediaan/Agen/kartu-stock-agen.vue'),
  },

  {
    path: '/Report/Penjualan/LapPenjualan',
    name: 'report-lap-penjualan',
    meta: {
      title: 'Lap. Penjualan',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-penjualan'),
  },
  {
    path: '/Report/agen/LapPenjualanAgen',
    name: 'report-lap-penjualan-agen',
    meta: {
      title: 'Lap. Penjualan',
      authRequired: true,
    },
    component: () => import('../views/Report/agen/lap-penjualan'),
  },

  {
    path: '/Report/Penjualan/LapPenjualanAgenReport',
    name: 'report-lap-penjualan-agen-report',
    meta: {
      title: 'Lap. Penjualan',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-penjualan-agen.vue'),
  },

  {
    path: '/Report/Penjualan/LapPenjualanPerSales',
    name: 'report-lap-penjualanPerSales',
    meta: {
      title: 'Lap. Penjualan Per Sales',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Penjualan/lap-penjualan-per-sales'),
  },
  {
    path: '/Report/Penjualan/LapPenjualanItem',
    name: 'report-lap-penjualanItem',
    meta: {
      title: 'Lap. Penjualan Per Item',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-penjualan-item'),
  },
  {
    path: '/Report/Penjualan/LapPenjualanItemAgen',
    name: 'report-lap-penjualanItemAgen',
    meta: {
      title: 'Lap. Penjualan Per Item',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Penjualan/lap-penjualan-item-agen'),
  },
  {
    path: '/Report/Penjualan/LapFixOrder',
    name: 'report-lap-fixOrder',
    meta: {
      title: 'Lap. Fix Order',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-fixorder'),
  },

  {
    path: '/Report/Penjualan/LapFixOrder',
    name: 'report-lap-fixOrderAgen',
    meta: {
      title: 'Lap. Fix Order Agen',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-fixorder-agen'),
  },

  {
    path: '/Report/Penjualan/LapPenjualanLaba',
    name: 'report-lap-penjualan-laba',
    meta: {
      title: 'Lap. Buku Penjualan',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-penjualan-laba'),
  },
  {
    path: '/Report/Penjualan/LapOutStanding',
    name: 'report-lap-outStanding',
    meta: {
      title: 'Lap. Out Standing',
      authRequired: true,
    },
    component: () => import('../views/Report/Penjualan/lap-out-standing'),
  },
  {
    path: '/Report/Penjualan/LapPembelian',
    name: 'report-lap-pembelian',
    meta: {
      title: 'Lap. Pembelian',
      authRequired: true,
    },
    component: () => import('../views/Report/Pembelian/lap-pembelian'),
  },

  {
    path: '/Report/Pembelian/LapOutStandingMigrationStock',
    name: 'report-lap-LapOutStandingMigrationStock',
    meta: {
      title: 'Lap. Out Standing Migration Stock',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Pembelian/lap-out-standing-kontainer'),
  },

  {
    path: '/Report/Penyesuaian/LapMigrationStock',
    name: 'report-lap-migrasi',
    meta: {
      title: 'Lap. Migration Stock',
      authRequired: true,
    },
    component: () => import('../views/Report/Penyesuaian/lap-migrasi'),
  },

  {
    path: '/Report/Penyesuaian/LapPenyesuaian',
    name: 'report-lap-penyesuaian',
    meta: {
      title: 'Lap. Penyesuaian',
      authRequired: true,
    },
    component: () => import('../views/Report/Penyesuaian/lap-penyesuaian'),
  },

  {
    path: '/Report/Penyesuaian/LapClaim',
    name: 'report-lap-claim',
    meta: {
      title: 'Lap. Claim',
      authRequired: true,
    },
    component: () => import('../views/Report/Penyesuaian/lap-claim'),
  },

  {
    path: '/Report/Penyesuaian/LapPinjaman',
    name: 'report-lap-pinjaman',
    meta: {
      title: 'Lap. Pinjaman',
      authRequired: true,
    },
    component: () => import('../views/Report/Penyesuaian/lap-pinjaman'),
  },

  {
    path: '/Report/keuangan/LapPosisiKasBank',
    name: 'report-lap-kasBank',
    meta: {
      title: 'Lap. Posisi Kas Bank',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/posisi-kas-bank'),
  },

  {
    path: '/Report/keuangan/LapPosisiPiutangCustomer',
    name: 'report-lap-piutangcustomer',
    meta: {
      title: 'Lap. Posisi Piutang Customer',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/posisi-piutang-customer'),
  },

  {
    path: '/Report/keuangan/LapKartuPiutangCustomer',
    name: 'report-lap-kartupiutangcustomer',
    meta: {
      title: 'Lap. Kartu Piutang Customer',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/keuangan/kartu-posisi_piutang_customer'),
  },

  {
    path: '/Report/keuangan/LapPosisiHutangSupplier',
    name: 'report-lap-hutangsupplier',
    meta: {
      title: 'Lap. Posisi Hutang Suplier',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/posisi-hutang-supplier'),
  },

  {
    path: '/Report/keuangan/LapKartuHutangSupplier',
    name: 'report-lap-kartuhutangsupplier',
    meta: {
      title: 'Lap. Kartu Hutang Supplier',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/keuangan/kartu-posisi_hutang_supplier'),
  },

  {
    path: '/Report/keuangan/LapKartuKasBank',
    name: 'report-lap-kartukasbank',
    meta: {
      title: 'Lap. Kartu Kas Bank',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/kartu-posisi_kas_bank'),
  },

  {
    path: '/Report/keuangan/LapBKMUMUM',
    name: 'report-lap-bkmumum',
    meta: {
      title: 'Lap. BKM UMUM',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/lap-bkmumum'),
  },

  {
    path: '/Report/keuangan/LapBKKUMUM',
    name: 'report-lap-bkkumum',
    meta: {
      title: 'Lap. BKK UMUM',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/lap-bkkumum'),
  },

  {
    path: '/Report/keuangan/LapBKMPENJUALAN',
    name: 'report-lap-bkmpenjualan',
    meta: {
      title: 'Lap. BKM PENJUALAN',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/lap-bkmpenjualan'),
  },

  {
    path: '/Report/keuangan/LapBKKPEMBELIAN',
    name: 'report-lap-bkkpembelian',
    meta: {
      title: 'Lap. BKK PEMBELIAN',
      authRequired: true,
    },
    component: () => import('../views/Report/keuangan/lap-bkkpembelian'),
  },

  {
    path: '/Report/absensi/LapAbsensi',
    name: 'report-lap-absensi',
    meta: {
      title: 'Lap. Absensi',
      authRequired: true,
    },
    component: () => import('../views/Report/Absensi/lap-absensi'),
  },

  {
    path: '/Report/absensi/LapAbsensiDetail',
    name: 'report-lap-absensi-detail',
    meta: {
      title: 'Lap. Absensi Detail',
      authRequired: true,
    },
    component: () => import('../views/Report/Absensi/lap-absensi-detail'),
  },

  {
    path: '/Report/absensi/agen/LapAbsensiAgen',
    name: 'report-lap-absensi-agen',
    meta: {
      title: 'Lap. Absensi',
      authRequired: true,
    },
    component: () => import('../views/Report/Absensi/Agen/lap-absensi-agen'),
  },

  {
    path: '/Report/absensi/agen/LapAbsensiAgenDetail',
    name: 'report-lap-absensi-agen-detail',
    meta: {
      title: 'Lap. Absensi Detail',
      authRequired: true,
    },
    component: () =>
      import('../views/Report/Absensi/Agen/lap-absensi-agen-detail'),
  },

  {
    path: '/logout',
    name: 'logout',
    meta: {
      title: 'Logout',
      // authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import('../views/account/logout'),
  },

  // PENGATURAN USER
  {
    path: '/settings/users/create',
    name: 'settings-users-create',
    meta: {
      title: 'User',
      authRequired: true,
    },
    component: () => import('../views/settings/users/create'),
  },
  {
    path: '/settings/users',
    name: 'settings-users',
    meta: {
      title: 'Daftar User',
      authRequired: true,
    },
    component: () => import('../views/settings/users/list'),
  },

  // PENGATURAN PARAMETER
  {
    path: '/settings/parameter',
    name: 'settings-parameter',
    meta: {
      title: 'Daftar Parameter',
      authRequired: true,
    },
    component: () => import('../views/settings/parameter/list'),
  },
  {
    path: '/settings/parameter/edit',
    name: 'settings-parameter-edit',
    meta: {
      title: 'Edit Parameter',
      authRequired: true,
    },
    component: () => import('../views/settings/parameter/edit'),
  },

  {
    path: '/settings/role/create',
    name: 'settings-role-create',
    meta: {
      title: 'Role',
      authRequired: true,
    },
    component: () => import('../views/settings/role/create'),
  },
  {
    path: '/settings/role',
    name: 'settings-role',
    meta: {
      title: 'Daftar Role',
      authRequired: true,
    },
    component: () => import('../views/settings/role/list'),
  },
];
